import React from "react"
import { Alert } from "react-bootstrap"
import FontAwesome from "react-fontawesome"

export default function FixRecordingInFineract({ running, error, onClick }) {

  return (
    <Alert bsStyle="warning">
    { running
      ? <span><FontAwesome name='clock-o'/> Running ..</span>
      : <span>
        { error ? error : 'An error occurred while recording this item.' } &nbsp;
        <span className="reloadSave" onClick={ onClick } title="Repair">
          Please click to repair <FontAwesome name='refresh'/>
        </span>
      </span>
    }
    </Alert>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/FixRecordingInFineract.js